var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('table-component',{attrs:{"fixed-header":"","id":_vm.model.toLowerCase() + '_elenco',"resource":_vm.polizza_index,"config":_vm.model.toLowerCase() + '-table',"toolbar-title":_vm.models,"loading":_vm.loading,"loading-text":"attendi un attimo","items-per-page":_vm.itemsPerPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }